import LevelBase from "./levelBase";
import { Empty, Exit, Interactive, NPCharacter, Player } from "../objects";
import EasyStar from "easystarjs";
import { translate } from "../../utils/localization";
import UI from "../UI";
import { TICK_TIME } from "../../utils/constants";
import template from "lodash.template";

class Level10 extends LevelBase {
  constructor() {
    super();
    this.easystar = new EasyStar.js();
    this.name = "The castle";
    this.diamondsGoal = 10;
    this.exit = null;
    this.dwarf = null;
    this.dwarfRun = false;
  }

  get id() {
    return this.constructor.key;
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);

    if (this.unfinished) {
      // erase method to animate exit destruction after talk to dwarf
      this.destroyBlock = () => false;

      // Path finder to exit for Dwarf
      const objectsAsKeys = this.objects.map((row) =>
        row.map((el) => (el.isClass(NPCharacter) || el.isClass(Empty) ? 0 : 1))
      );
      this.easystar.setGrid(objectsAsKeys);
      this.easystar.setAcceptableTiles([0]);

      // console.log(this.leader.position, this.exit.position, objectsAsKeys);
      this.easystar.findPath(
        this.leader.position.x,
        this.leader.position.y,
        this.exit.position.x - 3,
        this.exit.position.y,
        (path) => {
          this.leader.leadingPath = path.slice(1);
        }
      );
      this.easystar.calculate();
    } else {
      // removes dwarf if level was finished in the past
      this.leader.alien.alpha = 0;
      this.replaceByEmpty(this.leader);
    }
  }

  onInteractWith(el) {
    super.onInteractWith(el);

    // talk to Doc
    if (el.order === 0 && this.unfinished) {
      this.showDialog1();
    }

    // close to angel
    if (el.order === 1 && this.unfinished) {
      if (this.diamondsGoal <= this.collectedDiamonds) {
        this.clearPath();
      } else {
        // fall short of diamonds
        this.showDialog3();
      }
    }

    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }

  showDialog1() {
    this.scene.events.once("dialogue:hidden", () => {
      this.player.disconnect();
      // this.leader.isCloseEnough = () => this.dwarfRun;
      this.dwarfRun = true;
      this.moveDwarf();
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_10.dialog_1.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_10.dialog_1.dwarf_say_1")],
        },
      ],
    });
  }

  showDialog2() {
    this.scene.events.once("dialogue:hidden", () => {
      // remove listener since dwarf moves by himself
      this.scene.events.off("player_moves");
      // auto pilot off
      this.player.reconnect();
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary"],
      participantNames: ["Mary"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_10.dialog_2.mary_say_1")],
        },
      ],
    });
  }

  showDialog3() {
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Dwarf",
          text: [
            template(translate("level_10.dialog_3.dwarf_say_1"))({
              NUM: this.diamondsGoal,
            }),
          ],
        },
      ],
    });
  }

  moveDwarf() {
    // hack to auto move dwarf
    if (this.dwarfRun) {
      if (!this.leader.leadingPath.length) {
        this.dwarfRun = false;
      }

      this.onNextTick(() => {
        // hack: giving the leader position itself it will always return true for isCloseEnough calc since is closer than 3 blocks away.
        this.leader.onPlayerMoves(this.leader.position);
        // this.leader.animIdle();
        this.moveDwarf();
      });
    } else {
      this.leader.animIdle();
    }
    // shows dialog sonner to reduce player awaiting
    if (this.leader.leadingPath.length === 10) {
      this.leader.animIdle();
      this.showDialog2();
    }
  }

  clearPath() {
    // anim dwarf and angel dismiss
    this.scene.tweens.add({
      targets: this.exit.block.alien,
      x: UI.tileToScreen(this.exit.position.x),
      duration: TICK_TIME * 2,
      onComplete: () => this.exit.block.alien.destroy(),
    });

    this.leader.leadingPath = [
      { x: this.leader.position.x + 1, y: this.leader.position.y },
      { x: this.leader.position.x + 1, y: this.leader.position.y },
      { x: this.leader.position.x + 2, y: this.leader.position.y },
      { x: this.leader.position.x + 2, y: this.leader.position.y },
      { x: this.leader.position.x + 3, y: this.leader.position.y },
      { x: this.leader.position.x + 3, y: this.leader.position.y },
    ];
    this.player.disconnect();
    this.dwarfRun = true;
    this.moveDwarfToExit();
  }

  moveDwarfToExit() {
    // hack to auto move dwarf
    if (this.dwarfRun) {
      if (this.leader.position.x < this.exit.position.x) {
        this.onNextTick(() => {
          this.leader.onPlayerMoves(this.leader.position);
          // this.leader.animIdle();
          this.moveDwarfToExit();
        });
      } else {
        this.onNextTick(() => {
          this.replaceByEmpty(this.leader);
        });
        // this.leader.animIdle();
        // auto pilot off
        this.player.reconnect();
      }
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
      // // restore logic to allow overlap over exit interactive spot
      // this.scene.events.once("score:diamond_goal", () => el.canMove = el._canMove)
    }

    if (el.isClass(Exit)) {
      this.exit = el;
    }

    if (el.isClass(Interactive) && el.order === 1) {
      el.ephemeral = false;
      // once goal is reached, the interactive spot become ephemeral and it will be deleted after next interaction
      this.scene.events.once("score:diamond_goal", () => (el.ephemeral = true));
    }
  }
}

Level10.key = "level_10";
export default Level10;
